import request from '@/utils/request'

const dataObj = {
	version: '1.0',
	nonceStr: '1212fsadf',
	timestamp: '2020-4-21',
	signType: 'md5',
	content: {
		object: {
			merchantId: 1
		}
	},
	sign: 'dafdsf'
}
// 消费汇总-按食堂档口汇总
export function tradesumByCanteenexport (data) {
	const obj = JSON.parse(JSON.stringify(dataObj))
	if (data) {
		obj.content = data
	}
	return request({
		url: '/api/v1/simpleBudget/pre/canteen/page/export',
		method: 'post',
		data: obj,
		responseType: 'blob'
	})
}
// 消费汇总-按食堂档口汇总-优化
export function tradesumByCanteen2 (data) {
	const obj = JSON.parse(JSON.stringify(dataObj))
	if (data) {
		obj.content = data
	}
	return request({
		url: '/api/v1/simpleBudget/pre/canteen/page',
		method: 'post',
		data: obj
	})
}
// 消费汇总-按部门汇总-优化
export function tradesumByDeptexport (data) {
	const obj = JSON.parse(JSON.stringify(dataObj))
	if (data) {
		obj.content = data
	}
	return request({
		url: '/api/v1/simpleBudget/pre/org/page/export',
		method: 'post',
		data: obj,
		responseType: 'blob'
	})
}
// 消费汇总-按部门汇总-优化
export function tradesumByDept2 (data) {
	const obj = JSON.parse(JSON.stringify(dataObj))
	if (data) {
		obj.content = data
	}
	return request({
		url: '/api/v1/simpleBudget/pre/org/page',
		method: 'post',
		data: obj
	})
}
// 消费汇总-按部门汇总
export function tradesumByDept (data) {
	const obj = JSON.parse(JSON.stringify(dataObj))
	if (data) {
		obj.content = data
	}
	return request({
		url: '/api/v1/repreportform/pre/org/page',
		method: 'post',
		data: obj
	})
}

// 消费汇总-按设备汇总
export function tradesumByMachine (data) {
	const obj = JSON.parse(JSON.stringify(dataObj))
	if (data) {
		obj.content = data
	}
	return request({
		url: '/api/v1/repreportform/pre/mch/page',
		method: 'post',
		data: obj
	})
}

// 消费汇总-按个人汇总
export function tradesumByPersonal (data) {
	const obj = JSON.parse(JSON.stringify(dataObj))
	if (data) {
		obj.content = data
	}
	return request({
		url: '/api/v1/repreportform/pre/cust/page',
		method: 'post',
		data: obj
	})
}

// 消费汇总-按核身方式汇总
export function tradesumByNuclearmode (data) {
	const obj = JSON.parse(JSON.stringify(dataObj))
	if (data) {
		obj.content = data
	}
	return request({
		url: '/api/v1/repreportform/pre/nuclearmode/page',
		method: 'post',
		data: obj
	})
}

// 消费汇总-按人员类别汇总
export function tradesumByPsnType (data) {
	const obj = JSON.parse(JSON.stringify(dataObj))
	if (data) {
		obj.content = data
	}
	return request({
		url: '/api/v1/repreportform/pre/psntype/page',
		method: 'post',
		data: obj
	})
}

// 个人收支汇总
export function personalMoneySum (data) {
	const obj = JSON.parse(JSON.stringify(dataObj))
	if (data) {
		obj.content = data
	}
	return request({
		url: '/api/v1/repreportform/cust/account/change/page',
		method: 'post',
		data: obj
	})
}

// 菜品销售汇总
export function dishSaleSum (data) {
	const obj = JSON.parse(JSON.stringify(dataObj))
	if (data) {
		obj.content = data
	}
	return request({
		url: '/api/v1/repdishsale/rep/dishsum/page',
		method: 'post',
		data: obj
	})
}

// 销售情况分析表
export function saleAnalysisDetail (data) {
	const obj = JSON.parse(JSON.stringify(dataObj))
	if (data) {
		obj.content = data
	}
	return request({
		url: '/api/v1/repreportform/sale/analysis/page',
		method: 'post',
		data: obj
	})
}

// 系运行情况表
export function sysOperationForm (data) {
	const obj = JSON.parse(JSON.stringify(dataObj))
	if (data) {
		obj.content = data
	}
	return request({
		url: '/api/v1/sysoperation/rep/sys/ope',
		method: 'post',
		data: obj
	})
}

// 多条件查询充值汇总-个人汇总
export function getRechargeSum (data) {
	const obj = JSON.parse(JSON.stringify(dataObj))
	if (data) {
		obj.content = data
	}
	return request({
		url: '/api/v1/rechargeform/recharge/sum/page',
		method: 'post',
		data: obj
	})
}

// 多条件查询充值汇总-个人汇总
export function rechargeSumExport (data) {
	const obj = JSON.parse(JSON.stringify(dataObj))
	if (data) {
		obj.content = data
	}
	return request({
		url: '/api/v1/rechargeform/recharge/sum/page/export',
		method: 'post',
		data: obj,
		responseType: 'blob'
	})
}

// 多条件查询充值汇总-个人汇总 优化
export function getRechargeSum3 (data) {
	const obj = JSON.parse(JSON.stringify(dataObj))
	if (data) {
		obj.content = data
	}
	return request({
		url: '/api/v1/simpleBudget/rechargeTypeReport',
		method: 'post',
		data: obj
	})
}
// 多条件查询充值汇总-个人汇总 优化
export function getRechargeSumexport (data) {
	const obj = JSON.parse(JSON.stringify(dataObj))
	if (data) {
		obj.content = data
	}
	return request({
		url: '/api/v1/simpleBudget/exportRechargeTypeReport',
		method: 'post',
		data: obj,
		responseType: 'blob'
	})
}
// 多条件查询充值汇总-部门汇总
export function getRechargeDeptSum (data) {
	const obj = JSON.parse(JSON.stringify(dataObj))
	if (data) {
		obj.content = data
	}
	return request({
		url: '/api/v1/rechargeform/recharge/dept/sum/page',
		method: 'post',
		data: obj
	})
}

// 多条件查询充值汇总-部门汇总
export function rechargeDeptSumExport (data) {
	const obj = JSON.parse(JSON.stringify(dataObj))
	if (data) {
		obj.content = data
	}
	return request({
		url: '/api/v1/rechargeform/recharge/dept/sum/page/export',
		method: 'post',
		data: obj,
		responseType: 'blob'
	})
}
// 多条件查询取款记录 -- 新
export function getWithdrawalRecordNew (data) {
	const obj = JSON.parse(JSON.stringify(dataObj))
	if (data) {
		obj.content = data
	}
	return request({
		url: '/api/v2/expend/withdrawal/record',
		method: 'post',
		data: obj
	})
}

// 多条件查询取款记录
export function getWithdrawalRecord (data) {
	const obj = JSON.parse(JSON.stringify(dataObj))
	if (data) {
		obj.content = data
	}
	return request({
		url: '/api/v1/rechargeform/withdrawal/record/page',
		method: 'post',
		data: obj
	})
}

// 实时查询交易明细
export function getOrdTradeDetail (data) {
	const obj = JSON.parse(JSON.stringify(dataObj))
	if (data) {
		obj.content = data
	}
	return request({
		url: '/api/v1/repflowdetail/flowdetailpage',
		method: 'post',
		data: obj
	})
}

// 操作员统计表
export function getOperatorCount (data) {
	const obj = JSON.parse(JSON.stringify(dataObj))
	if (data) {
		obj.content = data
	}
	return request({
		url: '/api/v1/sysoperation/rep/operatorsum',
		method: 'post',
		data: obj
	})
}

// 人员换卡记录表
export function personChangecard (data) {
	const obj = JSON.parse(JSON.stringify(dataObj))
	if (data) {
		obj.content = data
	}
	return request({
		url: '/api/v1/repreportform/acccardhist',
		method: 'post',
		data: obj
	})
}
// 人员办卡记录表
export function personAcccardsum (data) {
	const obj = JSON.parse(JSON.stringify(dataObj))
	if (data) {
		obj.content = data
	}
	return request({
		url: '/api/v1/repreportform/acccardsum',
		method: 'post',
		data: obj
	})
}
// 操作员统计表上缴金额
export function overDeliver (data) {
	const obj = JSON.parse(JSON.stringify(dataObj))
	if (data) {
		obj.content = data
	}
	return request({
		url: '/api/v1/sysoperation/rep/handinmoney',
		method: 'post',
		data: obj
	})
}
// 供应商供货统计报表
export function getfenleihuizong (data) {
	const obj = JSON.parse(JSON.stringify(dataObj))
	if (data) {
		obj.content = data
	}
	return request({
		url: '/api/v1/drpreport/category/into',
		method: 'post',
		data: obj
	})
}
// 原料单品出入库表
export function getfenleihuizongdan (data) {
	const obj = JSON.parse(JSON.stringify(dataObj))
	if (data) {
		obj.content = data
	}
	return request({
		url: '/api/v1/drpreport/material/into',
		method: 'post',
		data: obj
	})
}

// 供应商供货统计报表
export function getgongyingshang (data) {
	const obj = JSON.parse(JSON.stringify(dataObj))
	if (data) {
		obj.content = data
	}
	return request({
		url: '/api/v1/drpreport/supplier/supply',
		method: 'post',
		data: obj
	})
}

// 供应商明细统计报表
export function getgongyingshangmingxi (data) {
	const obj = JSON.parse(JSON.stringify(dataObj))
	if (data) {
		obj.content = data
	}
	return request({
		url: '/api/v1/drpreport/supplier/supply/detail',
		method: 'post',
		data: obj
	})
}

// 查询食堂档口菜品销售情况
export function getShitangcaipinxiaoshou (data) {
	const obj = JSON.parse(JSON.stringify(dataObj))
	if (data) {
		obj.content = data
	}
	return request({
		url: '/api/v1/repdishsale/rep/dishsum/getRepAreaDishSaleDishSumPage',
		method: 'post',
		data: obj
	})
}

// 查询菜品统计表
export function getCaipintongji (data) {
	const obj = JSON.parse(JSON.stringify(dataObj))
	if (data) {
		obj.content = data
	}
	return request({
		url: '/api/v1/replxreport/lxordsumpage',
		method: 'post',
		data: obj
	})
}
// 查询部门区域消费情况
export function getDepartmentxiaofei (data) {
	const obj = JSON.parse(JSON.stringify(dataObj))
	if (data) {
		obj.content = data
	}
	return request({
		url: '/api/v1/reppaymentsum/deptareasum',
		method: 'post',
		data: obj
	})
}

// 查询餐次统计表
export function getCancitongji (data) {
	const obj = JSON.parse(JSON.stringify(dataObj))
	if (data) {
		obj.content = data
	}
	return request({
		url: '/api/v1/replxreport/lxintervalordsumpage',
		method: 'post',
		data: obj
	})
}

// 查询人员统计表
export function getRenyuantongji (data) {
	const obj = JSON.parse(JSON.stringify(dataObj))
	if (data) {
		obj.content = data
	}
	return request({
		url: '/api/v1/replxreport/lxpsnordsumpage',
		method: 'post',
		data: obj
	})
}
// 查询就餐时段消费统计
export function getDeptpayxiaofei (data) {
	const obj = JSON.parse(JSON.stringify(dataObj))
	if (data) {
		obj.content = data
	}
	return request({
		url: '/api/v1/reppaymentsum/deptpaymentsum',
		method: 'post',
		data: obj,
		timeout: 100000
	})
}
// 查询就餐时段消费统计简表
export function getDeptpayxiaofei2 (data) {
	const obj = JSON.parse(JSON.stringify(dataObj))
	if (data) {
		obj.content = data
	}
	return request({
		url: '/api/v1/simpleBudget/deptReport',
		method: 'post',
		data: obj,
		timeout: 100000
	})
}
// 查询就餐时段消费统计简表-导出
export function getDeptpayxiaofeiexport (data) {
	const obj = JSON.parse(JSON.stringify(dataObj))
	if (data) {
		obj.content = data
	}
	return request({
		url: '/api/v1/simpleBudget/exportDeptReport',
		method: 'post',
		data: obj,
		responseType: 'blob'
	})
}
// 按日期收支汇总
export function getDatepaymentpage (data) {
	const obj = JSON.parse(JSON.stringify(dataObj))
	if (data) {
		obj.content = data
	}
	return request({
		url: '/api/v1/reppayment/datepaymentpage',
		method: 'post',
		data: obj,
		timeout: 100000
	})
}
// 按人员收支汇总
export function getPsnpaymentpage (data) {
	const obj = JSON.parse(JSON.stringify(dataObj))
	if (data) {
		obj.content = data
	}
	return request({
		url: '/api/v1/reppayment/psnpaymentpage',
		method: 'post',
		data: obj,
		timeout: 100000
	})
}
// 就餐人员详情
export function getJiucandetail (data) {
	const obj = JSON.parse(JSON.stringify(dataObj))
	if (data) {
		obj.content = data
	}
	return request({
		url: '/api/v1/replxreport/psnrepastlistpage',
		method: 'post',
		data: obj
	})
}
// 建行定制部门收支查询
export function getDeptjsjhpaymentsum (data) {
	const obj = JSON.parse(JSON.stringify(dataObj))
	if (data) {
		obj.content = data
	}
	return request({
		url: '/api/v1/reppaymentsum/deptjsjhpaymentsum',
		method: 'post',
		data: obj
	})
}
// 充值汇总查询
export function getRechargeSum2 (data) {
	const obj = JSON.parse(JSON.stringify(dataObj))
	if (data) {
		obj.content = data
	}
	return request({
		url: '/api/v1/rechargeform/recharge/sum/page',
		method: 'post',
		data: obj
	})
}
// 按就餐发放补贴查询
export function getCustordnum (data) {
	const obj = JSON.parse(JSON.stringify(dataObj))
	if (data) {
		obj.content = data
	}
	return request({
		url: '/api/v1/repreportform/custordnum/page',
		method: 'post',
		data: obj
	})
}
// 批量导入餐次补贴
export function exportCancibuties (data) {
	const obj = JSON.parse(JSON.stringify(dataObj))
	if (data) {
		obj.content = data
	}
	return request({
		url: '/api/v1/repreportform/batchImportCustOrdSub',
		headers: {
			'Content-Type': 'multipart/form-data'
		},
		method: 'post',
		data
	})
}
// 水控明细
export function getShuikongdetail (data) {
	const obj = JSON.parse(JSON.stringify(dataObj))
	if (data) {
		obj.content = data
	}
	return request({
		url: '/api/v1/repmacwater/infopage',
		method: 'post',
		data: obj
	})
}
// 水控汇总
export function getShuikonghuizong (data) {
	const obj = JSON.parse(JSON.stringify(dataObj))
	if (data) {
		obj.content = data
	}
	return request({
		url: '/api/v1/repmacwater/sumpage',
		method: 'post',
		data: obj
	})
}
// 人员就餐情况分析表
export function getPeoplejiucan (data) {
	const obj = JSON.parse(JSON.stringify(dataObj))
	if (data) {
		obj.content = data
	}
	return request({
		url: '/api/v1/replxreport/psnrepastalllistpage',
		method: 'post',
		data: obj
	})
}
// 节假日消费汇总(按食堂)
export function getHolidayssum (data) {
	const obj = JSON.parse(JSON.stringify(dataObj))
	if (data) {
		obj.content = data
	}
	return request({
		url: '/api/v1/repreportholiday/pre/canteen/page',
		method: 'post',
		data: obj
	})
}
// 节假日消费汇总(按部门)
export function getHolidayssumdept (data) {
	const obj = JSON.parse(JSON.stringify(dataObj))
	if (data) {
		obj.content = data
	}
	return request({
		url: '/api/v1/repreportholiday/pre/org/page',
		method: 'post',
		data: obj
	})
}
// 定制查询——个人消费汇总
export function getCustdailysum (data) {
	const obj = JSON.parse(JSON.stringify(dataObj))
	if (data) {
		obj.content = data
	}
	return request({
		url: '/api/v1/repcustommade/pre/custdailysum/page',
		method: 'post',
		data: obj
	})
}
// 定制查询——部门消费汇总
export function getOrgsum (data) {
	const obj = JSON.parse(JSON.stringify(dataObj))
	if (data) {
		obj.content = data
	}
	return request({
		url: '/api/v1/repcustommade/pre/orgsum/page',
		method: 'post',
		data: obj
	})
}
// 定制查询——订单明细
export function getOrderdetail (data) {
	const obj = JSON.parse(JSON.stringify(dataObj))
	if (data) {
		obj.content = data
	}
	return request({
		url: '/api/v1/repcustommademenu/pre/menuInfo/page',
		method: 'post',
		data: obj
	})
}
// 定制查询——订单汇总
export function getOrdersum (data) {
	const obj = JSON.parse(JSON.stringify(dataObj))
	if (data) {
		obj.content = data
	}
	return request({
		url: '/api/v1/repcustommademenu/pre/menuSum/page',
		method: 'post',
		data: obj
	})
}
// 对接消费机流水
export function getXiaofeiliushui (data) {
	const obj = JSON.parse(JSON.stringify(dataObj))
	if (data) {
		obj.content = data
	}
	return request({
		url: '/api/v1/repflowdetail/outconsume/flowdetailpage',
		method: 'post',
		data: obj
	})
}
// 对接消费机消费汇总
export function getXiaofeijisum (data) {
	const obj = JSON.parse(JSON.stringify(dataObj))
	if (data) {
		obj.content = data
	}
	return request({
		url: '/api/v1/repreportform/outconsume/sumpage',
		method: 'post',
		data: obj
	})
}
// 对接消费机菜品销售汇总
export function getXiaofeijidishsum (data) {
	const obj = JSON.parse(JSON.stringify(dataObj))
	if (data) {
		obj.content = data
	}
	return request({
		url: '/api/v1/repdishsale/rep/dishsum/outmenupage',
		method: 'post',
		data: obj
	})
}
// 商城商品销售汇总
export function getshopxiaoshousum (data) {
	const obj = JSON.parse(JSON.stringify(dataObj))
	if (data) {
		obj.content = data
	}
	return request({
		url: '/api/v1/repdishsale/rep/dishsum/shopstoremenupage',
		method: 'post',
		data: obj
	})
}

// 导出实时查询交易明细
export function exportOrdTradeDetail (data) {
	const obj = JSON.parse(JSON.stringify(dataObj))
	if (data) {
		obj.content = data
	}
	return request({
		url: '/api/v1/repflowdetail/exportFlowdetail',
		method: 'post',
		data: obj,
		responseType: 'blob'
	})
}

// 分页获取个人收支明细
export function getFlowDetailByPage (data) {
	const obj = JSON.parse(JSON.stringify(dataObj))
	if (data) {
		obj.content = data
	}
	return request({
		url: '/api/v1/reportcheck/getFlowDetailByPage',
		method: 'post',
		data: obj
	})
}

// 分页获取账户对账明细
export function getFlowTotalByPage (data) {
	const obj = JSON.parse(JSON.stringify(dataObj))
	if (data) {
		obj.content = data
	}
	return request({
		url: '/api/v1/reportcheck/getFlowTotalByPage',
		method: 'post',
		data: obj
	})
}
// 分页获取账户对账明细-优化
export function getFlowTotalByPage2 (data) {
	const obj = JSON.parse(JSON.stringify(dataObj))
	if (data) {
		obj.content = data
	}
	return request({
		url: '/api/v1/simpleBudget/personReport',
		method: 'post',
		data: obj
	})
}
// 分页获取账户对账明细-导出
export function getFlowTotalByPageexport (data) {
	const obj = JSON.parse(JSON.stringify(dataObj))
	if (data) {
		obj.content = data
	}
	return request({
		url: '/api/v1/simpleBudget/exportPersonReport',
		method: 'post',
		data: obj,
		responseType: 'blob'
	})
}
// 查询差额有问题的所有人员记录
export function getDifferFlowTotalList (data) {
	const obj = JSON.parse(JSON.stringify(dataObj))
	if (data) {
		obj.content = data
	}
	return request({
		url: '/api/v1/reportcheck/getDifferFlowTotalList',
		method: 'post',
		data: obj
	})
}

// 根据人员id查询出该人员的流水，以及截止每笔流水交易时间的差额
export function getFlowTotalDetailList (data) {
	const obj = JSON.parse(JSON.stringify(dataObj))
	if (data) {
		obj.content = data
	}
	return request({
		url: '/api/v1/reportcheck/getFlowTotalDetailPage',
		method: 'post',
		data: obj
	})
}

// 查询充值记录
export function getRechargeData (data) {
	const obj = JSON.parse(JSON.stringify(dataObj))
	if (data) {
		obj.content = data
	}
	return request({
		url: '/api/v1/reportcheck/getRechargeData/' + data,
		method: 'get',
		params: obj
	})
}

// 更新充值记录
export function updateRechargeData (data) {
	const obj = JSON.parse(JSON.stringify(dataObj))
	if (data) {
		obj.content = data
	}
	return request({
		url: '/api/v1/reportcheck/updateRechargeData',
		method: 'put',
		data: obj
	})
}

// 删除充值记录
export function removeRechargeData (data) {
	const obj = JSON.parse(JSON.stringify(dataObj))
	if (data) {
		obj.content = data
	}
	return request({
		url: '/api/v1/reportcheck/removeRechargeData/' + data,
		method: 'delete',
		data: obj
	})
}

// 查询消费记录
export function getOrderData (data) {
	const obj = JSON.parse(JSON.stringify(dataObj))
	if (data) {
		obj.content = data
	}
	return request({
		url: '/api/v1/reportcheck/getOrderData/' + data,
		method: 'get',
		params: obj
	})
}

// 更新消费记录
export function updateOrderData (data) {
	const obj = JSON.parse(JSON.stringify(dataObj))
	if (data) {
		obj.content = data
	}
	return request({
		url: '/api/v1/reportcheck/updateOrderData',
		method: 'put',
		data: obj
	})
}

// 删除消费记录
export function removeOrderData (data) {
	const obj = JSON.parse(JSON.stringify(dataObj))
	if (data) {
		obj.content = data
	}
	return request({
		url: '/api/v1/reportcheck/removeOrderData/' + data,
		method: 'delete',
		data: obj
	})
}

// 查询退款记录
export function getRefundData (data) {
	const obj = JSON.parse(JSON.stringify(dataObj))
	if (data) {
		obj.content = data
	}
	return request({
		url: '/api/v1/reportcheck/getRefundData/' + data,
		method: 'get',
		params: obj
	})
}

// 更新退款记录
export function updateRefundData (data) {
	const obj = JSON.parse(JSON.stringify(dataObj))
	if (data) {
		obj.content = data
	}
	return request({
		url: '/api/v1/reportcheck/updateRefundData',
		method: 'put',
		data: obj
	})
}

// 删除退款记录
export function removeRefundData (data) {
	const obj = JSON.parse(JSON.stringify(dataObj))
	if (data) {
		obj.content = data
	}
	return request({
		url: '/api/v1/reportcheck/removeRefundData/' + data,
		method: 'delete',
		data: obj
	})
}

// 消费汇总
export function getXiaofeisum (data) {
	const obj = JSON.parse(JSON.stringify(dataObj))
	if (data) {
		obj.content = data
	}
	return request({
		url: '/api/v1/repreportform/ord/sumpage',
		method: 'post',
		data: obj
	})
}
// 按支付方式汇总
export function tradesumByPayType (data) {
	const obj = JSON.parse(JSON.stringify(dataObj))
	if (data) {
		obj.content = data
	}
	return request({
		url: '/api/v1/repreportform/pre/paytype/page',
		method: 'post',
		data: obj
	})
}
// 按支付方式汇总 优化
export function tradesumByPayType2 (data) {
	const obj = JSON.parse(JSON.stringify(dataObj))
	if (data) {
		obj.content = data
	}
	return request({
		url: '/api/v1/simpleBudget/payTypeReport',
		method: 'post',
		data: obj
	})
}
// 个人每月补贴&充值消费明细表
export function getLibaiCustMonthTradeSum (data) {
	const obj = JSON.parse(JSON.stringify(dataObj))
	if (data) {
		obj.content = data
	}
	return request({
		url: '/api/v1/repcustommade/libai/custmonthtradesum/page',
		method: 'post',
		data: obj
	})
}
// 个人月度总消费表
export function getLibaiCustMonthOrdSum (data) {
	const obj = JSON.parse(JSON.stringify(dataObj))
	if (data) {
		obj.content = data
	}
	return request({
		url: '/api/v1/repcustommade/libai/custmonthordsum/page',
		method: 'post',
		data: obj
	})
}
// 按支付方式汇总 优化导出
export function tradesumByPayTypeexport (data) {
	const obj = JSON.parse(JSON.stringify(dataObj))
	if (data) {
		obj.content = data
	}
	return request({
		url: '/api/v1/simpleBudget/exportPayTypeReport',
		method: 'post',
		data: obj,
		responseType: 'blob'
	})
}
// 按支付方式分餐词汇总 优化导出
export function tradesumCanciByPayTypeexport (data) {
	const obj = JSON.parse(JSON.stringify(dataObj))
	if (data) {
		obj.content = data
	}
	return request({
		url: '/api/v1/repreportform/pre/paytype/page/export',
		method: 'post',
		data: obj,
		responseType: 'blob'
	})
}
// 按操作员消费汇总
export function getOptsum (data) {
	const obj = JSON.parse(JSON.stringify(dataObj))
	if (data) {
		obj.content = data
	}
	return request({
		url: '/api/v1/repreportform/ord/optsumpage',
		method: 'post',
		data: obj
	})
}
// 每日消费明细表
export function getLibaiTradeInfo (data) {
	const obj = JSON.parse(JSON.stringify(dataObj))
	if (data) {
		obj.content = data
	}
	return request({
		url: '/api/v1/repcustommade/libai/tradeinfo/page',
		method: 'post',
		data: obj
	})
}
// 个人每餐消费次数补贴
export function getCustordnumsub (data) {
	const obj = JSON.parse(JSON.stringify(dataObj))
	if (data) {
		obj.content = data
	}
	return request({
		url: '/api/v1/repconsumesub/custordnumsub/page',
		method: 'post',
		data: obj
	})
}
// 余额变动情况表
export function getRechargeform (data) {
	const obj = JSON.parse(JSON.stringify(dataObj))
	if (data) {
		obj.content = data
	}
	return request({
		url: '/api/v1/rechargeform/accbal/page',
		method: 'post',
		data: obj
	})
}
// 导出操作员统计表
export function exportOperatorCount (data) {
	const obj = JSON.parse(JSON.stringify(dataObj))
	if (data) {
		obj.content = data
	}
	return request({
		url: '/api/v1/sysoperation/rep/operatorsum/export',
		method: 'post',
		data: obj,
		responseType: 'blob'
	})
}
// 导出设备汇总
export function exportReportFormPreMchPage (data) {
	const obj = JSON.parse(JSON.stringify(dataObj))
	if (data) {
		obj.content = data
	}
	return request({
		url: '/api/v1/repreportform/pre/mch/page/export',
		method: 'post',
		data: obj,
		responseType: 'blob'
	})
}

// 导出个人消费汇总
export function exportReportFormPreCustPage (data) {
	const obj = JSON.parse(JSON.stringify(dataObj))
	if (data) {
		obj.content = data
	}
	return request({
		url: '/api/v1/repreportform/pre/cust/page/export',
		method: 'post',
		data: obj,
		responseType: 'blob'
	})
}

// 导出操作员消费汇总
export function exportRepReportOptOrdSumPage (data) {
	const obj = JSON.parse(JSON.stringify(dataObj))
	if (data) {
		obj.content = data
	}
	return request({
		url: '/api/v1/repreportform/ord/optsumpage/export',
		method: 'post',
		data: obj,
		responseType: 'blob'
	})
}

// 导出收支汇总-部门收支汇总
export function exportRepDeptPaymentSumPage (data) {
	const obj = JSON.parse(JSON.stringify(dataObj))
	if (data) {
		obj.content = data
	}
	return request({
		url: '/api/v1/reppaymentsum/deptpaymentsum/export',
		method: 'post',
		data: obj,
		responseType: 'blob'
	})
}

// 导出按日期收支汇总
export function exportDatePaymentPage (data) {
	const obj = JSON.parse(JSON.stringify(dataObj))
	if (data) {
		obj.content = data
	}
	return request({
		url: '/api/v1/reppayment/datepaymentpage/export',
		method: 'post',
		data: obj,
		responseType: 'blob'
	})
}

// 导出按人员收支汇总
export function exportPsnPaymentPage (data) {
	const obj = JSON.parse(JSON.stringify(dataObj))
	if (data) {
		obj.content = data
	}
	return request({
		url: '/api/v1/reppayment/psnpaymentpage/export',
		method: 'post',
		data: obj,
		responseType: 'blob'
	})
}

// 导出菜品销售汇总
export function exportRepAreaDishSaleDishSumPage (data) {
	const obj = JSON.parse(JSON.stringify(dataObj))
	if (data) {
		obj.content = data
	}
	return request({
		url: '/api/v1/repdishsale/rep/dishsum/getRepAreaDishSaleDishSumPage/export',
		method: 'post',
		data: obj,
		responseType: 'blob'
	})
}

// 导出核身方式汇总汇总
export function exportReportFormPreNuclearmodePage (data) {
	const obj = JSON.parse(JSON.stringify(dataObj))
	if (data) {
		obj.content = data
	}
	return request({
		url: '/api/v1/repreportform/pre/nuclearmode/page/export',
		method: 'post',
		data: obj,
		responseType: 'blob'
	})
}

// 导出人员就餐明细
export function exportPsnRepastListPage (data) {
	const obj = JSON.parse(JSON.stringify(dataObj))
	if (data) {
		obj.content = data
	}
	return request({
		url: '/api/v1/replxreport/psnrepastlistpage/export',
		method: 'post',
		data: obj,
		responseType: 'blob'
	})
}

// 导出销售情况分析表
export function exportSaleAnalysisPage (data) {
	const obj = JSON.parse(JSON.stringify(dataObj))
	if (data) {
		obj.content = data
	}
	return request({
		url: '/api/v1/repreportform/sale/analysis/page/export',
		method: 'post',
		data: obj,
		responseType: 'blob'
	})
}

export function exportPsnRepastAllListPage (data) {
	const obj = JSON.parse(JSON.stringify(dataObj))
	if (data) {
		obj.content = data
	}
	return request({
		url: '/api/v1/replxreport/psnrepastalllistpage/export',
		method: 'post',
		data: obj,
		responseType: 'blob'
	})
}
// 消费汇总
export const getConsumeSumList = (data) => {
	return request({
		url: '/api/v1/repreportform/pre/consumesum/page',
		method: 'post',
		data: { ...dataObj, content: data || undefined }
	})
}
// 消费汇总导出
export const consumeSumListExport = (data) => {
	return request({
		url: '/api/v1/repreportform/pre/consumesum/export',
		method: 'post',
		responseType: 'blob',
		data: { ...dataObj, content: data || undefined }
	})
}
// 获取设备列表
export const getConsumeDeviceList = (data) => {
	return request({
		url: '/api/v1/common/mac/list',
		method: 'post',
		data: { ...dataObj, content: data || undefined }
	})
}

// 账户余额汇总
export function getZhanghuList (data) {
	const obj = JSON.parse(JSON.stringify(dataObj))
	if (data) {
		obj.content = data
	}
	return request({
		url: '/api/v1/simpleBudget/queryPageAccInfo',
		method: 'post',
		data: obj
	})
}
// 获取需要纠错的订单
export function getneedredress (data) {
	const obj = JSON.parse(JSON.stringify(dataObj))
	if (data) {
		obj.content = data
	}
	return request({
		url: '/api/v1/common/buffet/getneedredressbypage',
		method: 'get',
		params: obj
	})
}
// 获取需要纠错的订单详情
export function getneedredressdetail (data) {
	const obj = JSON.parse(JSON.stringify(dataObj))
	if (data) {
		obj.content = data
	}
	return request({
		url: '/api/v1/common/buffet/getneedredressdetail',
		method: 'post',
		data: obj
	})
}
// 纠错审核
export function redressupdate (data) {
	const obj = JSON.parse(JSON.stringify(dataObj))
	if (data) {
		obj.content = data
	}
	return request({
		url: '/api/v1/common/buffet/redressupdate',
		method: 'post',
		data: obj
	})
}
// 账户余额导出
export const getZhanghuListExport = (data) => {
	return request({
		url: '/api/v1/simpleBudget/queryPageAccInfo/export',
		method: 'post',
		responseType: 'blob',
		data: { ...dataObj, content: data || undefined }
	})
}

// 消费次数统计表
export function getOrgordnumdz (data) {
	const obj = JSON.parse(JSON.stringify(dataObj))
	if (data) {
		obj.content = data
	}
	return request({
		url: '/api/v1/repreportform/ord/orgordnumdz',
		method: 'post',
		data: obj
	})
}

// 消费次数统计表导出
export function exportOrgordnumdz (data) {
	const obj = JSON.parse(JSON.stringify(dataObj))
	if (data) {
		obj.content = data
	}
	return request({
		url: '/api/v1/repreportform/ord/orgordnumdz/export',
		method: 'post',
		data: obj,
		responseType: 'blob'
	})
}
// 新增厨余记录
export function addKitchenResidue (data) {
	const obj = JSON.parse(JSON.stringify(dataObj))
	if (data) {
		obj.content = data
	}
	return request({
		url: '/api/v1/report/kitchenresidue/addKitchenResidue',
		method: 'post',
		data: obj
	})
}
// 编辑厨余记录
export function editKitchenResidue (data) {
	const obj = JSON.parse(JSON.stringify(dataObj))
	if (data) {
		obj.content = data
	}
	return request({
		url: '/api/v1/report/kitchenresidue/editKitchenResidue',
		method: 'post',
		data: obj
	})
}
// 查询厨余记录
export function kitchenwastereportPage (data) {
	const obj = JSON.parse(JSON.stringify(dataObj))
	if (data) {
		obj.content = data
	}
	return request({
		url: '/api/v1/report/kitchenresidue/page',
		method: 'get',
		params: obj
	})
}
// 删除厨余记录
export function deleteKitchenResidue (data) {
	const obj = JSON.parse(JSON.stringify(dataObj))
	if (data) {
		obj.content = data
	}
	return request({
		url: '/api/v1/report/kitchenresidue/deleteKitchenResidue',
		method: 'post',
		data: obj
	})
}
/**
	 * 查询厨余导入失败结果
	 * */
export function kitchenwastereportErrPage (data) {
	const obj = JSON.parse(JSON.stringify(dataObj))
	if (data) {
		obj.content = data
	}
	return request({
		url: '/api/v1/report/kitchenresidue/page-batch-error',
		method: 'post',
		data: obj
	})
}
// 导入厨余记录
export function batchImportKitchenResidue (data) {
	const obj = JSON.parse(JSON.stringify(dataObj))
	if (data) {
		obj.content = data
	}
	return request({
		url: '/api/v1/report/kitchenresidue/batchImportKitchenResidue',
		headers: {
			'Content-Type': 'multipart/form-data'
		},
		method: 'post',
		data
	})
}

// 新版报表
// 营业收入明细
export const flowSummary = data => {
	return request({
		url: '/summary/basic/flow/page',
		method: 'post',
		data: { ...dataObj, content: data || undefined }
	})
}

// 导出营业收入明细
export const exportFlowSummary = data => {
	return request({
		url: '/summary/basic/flow/export',
		method: 'post',
		data: { ...dataObj, content: data || undefined },
		responseType: 'blob'
	})
}

// 食堂档口汇总
export const canteenSummary = data => {
	return request({
		url: '/summary/order/canteen/page',
		method: 'post',
		data: { ...dataObj, content: data || undefined }
	})
}

// 导出食堂档口汇总
export const exportCanteenSummary = data => {
	return request({
		url: '/summary/order/canteen/export',
		method: 'post',
		data: { ...dataObj, content: data || undefined },
		responseType: 'blob'
	})
}

// 菜品/商品销售明细
export const goodsSummary = data => {
	return request({
		url: '/summary/order/goods/page',
		method: 'post',
		data: { ...dataObj, content: data || undefined }
	})
}

// 菜品/商品销售明细
export const exportGoodsSummary = data => {
	return request({
		url: '/summary/order/goods/export',
		method: 'post',
		data: { ...dataObj, content: data || undefined },
		responseType: 'blob'
	})
}

// 按设备收入汇总
export const machineSummary = data => {
	return request({
		url: '/summary/order/machine/page',
		method: 'post',
		data: { ...dataObj, content: data || undefined }
	})
}

// 按设备收入汇总
export const exportMachineSummary = data => {
	return request({
		url: '/summary/order/machine/export',
		method: 'post',
		data: { ...dataObj, content: data || undefined },
		responseType: 'blob'
	})
}

// 按组织收入汇总
export const organizationSummary = data => {
	return request({
		url: '/summary/order/organization/page',
		method: 'post',
		data: { ...dataObj, content: data || undefined }
	})
}

// 按组织收入汇总
export const exportOrganizationSummary = data => {
	return request({
		url: '/summary/order/organization/export',
		method: 'post',
		data: { ...dataObj, content: data || undefined },
		responseType: 'blob'
	})
}
// 个人每餐消费次数补贴
export function getCustOrdNumSubPage (data) {
	const obj = JSON.parse(JSON.stringify(dataObj))
	if (data) {
		obj.content = data
	}
	return request({
		url: '/api/v1/repreportform/custordnumsub/page',
		method: 'post',
		data: obj
	})
}

// 个人每餐消费次数补贴导出
export function exportCustOrdNumSub (data) {
	const obj = JSON.parse(JSON.stringify(dataObj))
	if (data) {
		obj.content = data
	}
	return request({
		url: '/api/v1/repreportform/custordnumsub/export',
		method: 'post',
		data: obj,
		responseType: 'blob'
	})
}
// 按支付渠道收入汇总
export const paySummary = data => {
	return request({
		url: '/summary/order/pay/page',
		method: 'post',
		data: { ...dataObj, content: data || undefined }
	})
}

// 按支付渠道收入汇总
export const exportPaySummary = data => {
	return request({
		url: '/summary/order/pay/export',
		method: 'post',
		data: { ...dataObj, content: data || undefined },
		responseType: 'blob'
	})
}

// 按人员类别收入汇总
export const typeSummary = data => {
	return request({
		url: '/summary/order/type/page',
		method: 'post',
		data: { ...dataObj, content: data || undefined }
	})
}

// 按人员类别收入汇总
export const exportTypeSummary = data => {
	return request({
		url: '/summary/order/type/export',
		method: 'post',
		data: { ...dataObj, content: data || undefined },
		responseType: 'blob'
	})
}

// 分餐次收入汇总
export const mealtimeSummary = data => {
	return request({
		url: '/summary/order/mealtime/page',
		method: 'post',
		data: { ...dataObj, content: data || undefined }
	})
}

// 分餐次收入汇总
export const exportMealtimeSummary = data => {
	return request({
		url: '/summary/order/mealtime/export',
		method: 'post',
		data: { ...dataObj, content: data || undefined },
		responseType: 'blob'
	})
}

// 重新统计报表数据
export const fixSummary = data => {
	return request({
		url: '/summary/fix/order',
		method: 'post',
		data: { ...dataObj, content: data || undefined }
	})
}

// 重新统计账户报表数据
export const fixSummaryAcc = data => {
	return request({
		url: '/summary/account/fix',
		method: 'post',
		data: { ...dataObj, content: data || undefined }
	})
}

// 用户构成分析
export const custAnalysis = data => {
	return request({
		url: '/summary/analysis/cust/page',
		method: 'post',
		data: { ...dataObj, content: data || undefined }
	})
}

// 导出用户构成分析
export const exportCustAnalysis = data => {
	return request({
		url: '/summary/analysis/cust/export',
		method: 'post',
		data: { ...dataObj, content: data || undefined },
		responseType: 'blob'
	})
}

// 食堂满意度统计
export const evaluateAnalysis = data => {
	return request({
		url: '/summary/analysis/evaluate/page',
		method: 'post',
		data: { ...dataObj, content: data || undefined }
	})
}

// 导出食堂满意度统计
export const exportEvaluateAnalysis = data => {
	return request({
		url: '/summary/analysis/evaluate/export',
		method: 'post',
		data: { ...dataObj, content: data || undefined },
		responseType: 'blob'
	})
}

// 菜品销售排行
export const dishesSaleAnalysis = data => {
	return request({
		url: '/summary/analysis/dishes/sale/page',
		method: 'post',
		data: { ...dataObj, content: data || undefined }
	})
}

// 导出菜品销售排行
export const exportDishesSaleAnalysis = data => {
	return request({
		url: '/summary/analysis/dishes/sale/export',
		method: 'post',
		data: { ...dataObj, content: data || undefined },
		responseType: 'blob'
	})
}

// 充值渠道汇总
export const getRechargeChannel = data => {
	return request({
		url: '/summary/account/recharge/channel/page',
		method: 'post',
		data: { ...dataObj, content: data || undefined }
	})
}

// 充值渠道汇总
export const exportRechargeChannel = data => {
	return request({
		url: '/summary/account/recharge/channel/export',
		method: 'post',
		data: { ...dataObj, content: data || undefined },
		responseType: 'blob'
	})
}

// 人员类别充值汇总
export const getRechargeType = data => {
	return request({
		url: '/summary/account/recharge/type/page',
		method: 'post',
		data: { ...dataObj, content: data || undefined }
	})
}

// 人员类别充值汇总
export const exportRechargeType = data => {
	return request({
		url: '/summary/account/recharge/type/export',
		method: 'post',
		data: { ...dataObj, content: data || undefined },
		responseType: 'blob'
	})
}

// 充值来源汇总
export const getRechargeSource = data => {
	return request({
		url: '/summary/account/recharge/source/page',
		method: 'post',
		data: { ...dataObj, content: data || undefined }
	})
}

// 充值来源汇总
export const exportRechargeSource = data => {
	return request({
		url: '/summary/account/recharge/source/export',
		method: 'post',
		data: { ...dataObj, content: data || undefined },
		responseType: 'blob'
	})
}

// 组织充值汇总
export const getRechargeOrganization = data => {
	return request({
		url: '/summary/account/recharge/organization/page',
		method: 'post',
		data: { ...dataObj, content: data || undefined }
	})
}

// 组织充值汇总
export const exportRechargeOrganization = data => {
	return request({
		url: '/summary/account/recharge/organization/export',
		method: 'post',
		data: { ...dataObj, content: data || undefined },
		responseType: 'blob'
	})
}

// 营业分析 - 图表
export const getAnalysisTurnover = data => {
	return request({
		url: '/summary/analysis/turnover',
		method: 'post',
		data: { ...dataObj, content: data || undefined }
	})
}
// 根据充值来源选择充值设备
export const getRechargeShebei = data => {
	const obj = JSON.parse(JSON.stringify(dataObj))
	if (data) {
		obj.content = data
	}
	return request({
		url: '/api/v2/device/page',
		method: 'get',
		params: obj
	})
}

// 营业分析 - 报表
export const getAnalysisTurnoverDetail = data => {
	return request({
		url: '/summary/analysis/turnover/detail',
		method: 'post',
		data: { ...dataObj, content: data || undefined }
	})
}

// 充值分析-报表
export const getAnalysisRechargeDetail = data => {
	return request({
		url: '/summary/analysis/recharge/detail',
		method: 'post',
		data: { ...dataObj, content: data || undefined }
	})
}

// 充值分析汇总
export const getAnalysisRechargeTotal = data => {
	return request({
		url: '/summary/analysis/recharge/total',
		method: 'post',
		data: { ...dataObj, content: data || undefined }
	})
}

// 充值趋势分析
export const getAnalysisRechargeTrend = data => {
	return request({
		url: '/summary/analysis/recharge/trend',
		method: 'post',
		data: { ...dataObj, content: data || undefined }
	})
}

// 顾客分析汇总-按性别
export const getAnalysisCustomerSex = data => {
	return request({
		url: '/summary/analysis/customer-sex/total',
		method: 'post',
		data: { ...dataObj, content: data || undefined }
	})
}

// 顾客分析汇总-按人员类别
export const getAnalysisCustomerType = data => {
	return request({
		url: '/summary/analysis/customer-type/total',
		method: 'post',
		data: { ...dataObj, content: data || undefined }
	})
}

// 顾客分析-用户留存
export const getAnalysisCustomerRetain = data => {
	return request({
		url: '/summary/analysis/customer/retain',
		method: 'post',
		data: { ...dataObj, content: data || undefined }
	})
}

// 顾客分析汇总-柱状图
export const getAnalysisCustomerTrend = data => {
	return request({
		url: '/summary/analysis/customer/total/trend',
		method: 'post',
		data: { ...dataObj, content: data || undefined }
	})
}

// 顾客分析汇总-柱状图
export const getAnalysisCustomerDetail = data => {
	return request({
		url: '/summary/analysis/customer/detail',
		method: 'post',
		data: { ...dataObj, content: data || undefined }
	})
}

// 设备分析-汇总
export const getAnalysisDeviceTotal = data => {
	return request({
		url: '/summary/analysis/device/total',
		method: 'post',
		data: { ...dataObj, content: data || undefined }
	})
}

// 设备分析-各餐次汇总
export const getAnalysisDeviceMealtimeTotal = data => {
	return request({
		url: '/summary/analysis/device/mealtime-total',
		method: 'post',
		data: { ...dataObj, content: data || undefined }
	})
}

// 设备分析-按餐次统计各设备类型使用次数
export const getAnalysisDeviceMealtimeTypeTotal = data => {
	return request({
		url: '/summary/analysis/device/mealtime-type-total',
		method: 'post',
		data: { ...dataObj, content: data || undefined }
	})
}

// 设备分析-设备使用与分析报表
export const getAnalysisDeviceDetail = data => {
	return request({
		url: '/summary/analysis/device/detail',
		method: 'post',
		data: { ...dataObj, content: data || undefined }
	})
}
